<input type="hidden">
<div class="default text">{{placeholder}}</div>
<i class="dropdown icon"></i>
<div class="menu">
  <ng-container *ngFor="let item of items">
    <div
      [attr.data-value]="item.value"
      [ngClass]="item.class"
      class="item"
    >
      <i *ngIf="item.icon" [ngClass]="item.icon" class="icon"></i>
      <div *ngIf="item.color && !item.image" class="image" [style.backgroundColor]="item.color"></div>
      <img *ngIf="item.image" [style.backgroundColor]="item.color" [ngClass]="item.class" [src]="item.image">
      <div class="content">{{item.name}}</div>
    </div>
  </ng-container>
</div>